import { useState, useEffect, useMemo } from "react";

function useIsSmallScreen(maxWidth = 1024) {
  const query = useMemo(() => `(max-width: ${maxWidth}px)`, [maxWidth]);
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);

  useEffect(() => {
    const mql = window.matchMedia(query);
    setMatches(mql.matches);

    const handler = (e) => setMatches(e.matches);
    mql.addEventListener("change", handler);
    return () => mql.removeEventListener("change", handler);
  }, [query]);

  return matches;
}

export default useIsSmallScreen;
